export default {
      id: "sensors__oil_pressure-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__oil_pressure",
      toString: function () {
        return this.url;
      }
    }